import React from 'react';

const SkillComponent = ({ name, logo, stars }) => {
    return (
      <div className="skill-container">
        <div className="skill-header">
          <img src={logo} alt={name} />
        </div>
        <div>{name}</div>
        <div className="stars">
          {[...Array(5)].map((_, index) => (
            <span key={index} className={`star ${index < stars ? 'filled' : ''}`}>
              {index < stars ? '★' : '☆'}
            </span>
          ))}
        </div>
      </div>
    );
};

export const Skill = ({skills}) => {
    const renderSkillRow = (startIndex, count) => {
        const skillComponents = [];
        for (let j = 0; j < count && startIndex + j < skills.length; j++) {
            skillComponents.push(
                <SkillComponent key={startIndex + j}
                    name={skills[startIndex + j].name}
                    logo={skills[startIndex + j].logo}
                    stars={skills[startIndex + j].stars}
                />
            );
        }
        return (
            <div className="skill-row" key={startIndex}>
                {skillComponents}
            </div>
        );
    };

    const rows = [];
    const itemsPerRow = window.innerWidth <= 768 ? 2 : 5; // モバイルでは2列、PCでは5列

    for (let i = 0; i < skills.length; i += itemsPerRow) {
        rows.push(renderSkillRow(i, itemsPerRow));
    }

    return (
        <div className="skills-container">
            {rows}
        </div>
    );
};